import { asISODate } from 'lib/helpers/asISODate/asISODate'
import { getPacificToday } from 'lib/helpers/getPacificToday/getPacificToday'

export const dates = {
  previous: asISODate('2026-03-19'),
  latest: asISODate('2026-10-27'),
} as const

export const getCurrentTosEffectiveDate = (): ISODate =>
  getPacificToday() >= dates.latest ? dates.latest : dates.previous
